module.exports = __webpack_public_path__ + "img/breathblurgray.f0b82aed.jpg";